import history from 'app/history';
import { getPageContentFromCms } from 'app/modules/cms/service/cms-service';
import { associativeCmsMap } from 'app/modules/cms/tools/mapper';
import { initializeInsuredGoods } from 'app/modules/corporate/service/corporate.service';
import { Accessibility } from 'app/modules/corporate/service/store/corporate.state';
import { saveCustomer } from 'app/modules/customer/service/customer.service';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { createPendingSubscription, createPendingSubscriptionProcess, getSubscription, initializeJourney, updateCustomerSubscription } from 'app/modules/subscription/service/subscription-service';
import { isNull } from 'lodash';
import { journeyApi } from '../api';
import { associativeGtmStepNameMap, associativeStepMap } from '../ui/tools/mappers';
import { returnComponent } from '../ui/tools/methods';
import { ACTION_TYPES } from './store/step.actions';
import { StepActions } from './store/step.state';

export const majCmsContent = () => async (dispatch, getState) => {
  const stepStore = await getState().step;
  const currentPageType = stepStore.journeySteps[stepStore.journeyStepsList[stepStore.currentStep - 1]].cmsType;

  if (currentPageType !== undefined) {
    const cmsStore = await getState().cms;
    let cmsContentPageType = cmsStore.content[currentPageType];

    if (cmsContentPageType === undefined) {
      await dispatch(getPageContentFromCms(currentPageType));
    }

    cmsContentPageType = await getState().cms.content[currentPageType];
  }
};

export const buildSteps = () => async (dispatch, getState) => {
  const { isLoaded } = await getState().step;
  if (isLoaded) return; // si déjà loaded, stop

  const { selectedOffer } = await getState().offers;

  const offerAccessibility = selectedOffer.accessibility;

  const { steps, pendingSubscription } = await getState().config;

  let journeyStepsList = [];

  switch (offerAccessibility) {
    case Accessibility.PROFESSIONAL:
      journeyStepsList = [...steps.pro];
      break;
    case Accessibility.INDIVIDUAL:
      journeyStepsList = [...steps.part];
      break;
    default:
      journeyStepsList = [...steps.part];
      break;
  }

  const journeySteps: { [id: string]: any } = {};
  journeyStepsList.map((element, i) => {
    const step = {
      component: returnComponent(associativeStepMap.get(element)),
      cmsType: associativeCmsMap.get(element),
      showStepActions: true
    };

    journeySteps[element] = step;
  });

  // Add first step
  if (offerAccessibility) {
    journeyStepsList.unshift('confirmOfferStep');
  }

  if (pendingSubscription) {
    journeyStepsList.push('confirmationBarcodeStep');
  } else {
    journeyStepsList.push('confirmationStep');
  }

  journeyStepsList.push('cancellationStep');

  journeyStepsList.push('tooLateStep');

  journeyStepsList.push('tooEarlyStep');

  await dispatch({
    type: ACTION_TYPES.SET_JOURNEY_STEPS,
    payload: { journeySteps, journeyStepsList }
  });
};

export const setStepActions = ({
  actionBeforePreviousStep,
  actionBeforeNextStep,
  actionNextStep,
  previousButtonLabel,
  nextButtonLabel,
  showPreviousButton,
  showNextButton,
  disableButtons,
  disablePreviousButton,
  disableNextButton,
  form,
  fullSize
}: StepActions) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.SET_STEPS_ACTIONS,
    payload: {
      actionBeforePreviousStep,
      actionBeforeNextStep,
      actionNextStep,
      previousButtonLabel,
      nextButtonLabel,
      showPreviousButton,
      showNextButton,
      disableButtons,
      disablePreviousButton,
      disableNextButton,
      form,
      fullSize
    }
  });
};

export const disableButton = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.DISABLE_BUTTONS,
    payload: {
      disableButtons: true
    }
  });
};

export const disablePreviousBtn = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.DISABLE_PREVIOUS_BUTTON,
    payload: {
      disablePreviousButton: true
    }
  });
};

export const disableNextBtn = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.DISABLE_NEXT_BUTTON,
    payload: {
      disableNextButton: true
    }
  });
};

export const initStep = () => (dispatch, getState) => {
  dispatch(majCmsContent());
};

export const goToStep = (stepName: string) => async (dispatch, getState) => {
  const { journeyStepsList, currentStep } = await getState().step;

  await dispatch({
    type: ACTION_TYPES.UPDATE_STEP,
    payload: { previousStep: currentStep, currentStep: journeyStepsList.indexOf(stepName) + 1 }
  });
};

export const goSpecificStep = (dispatch: Function, actionType: string, currentStep: number, previousStep: number | null = null) => {
  dispatch({
    type: actionType,
    payload: {
      previousStep,
      currentStep
    }
  });

  dispatch(majCmsContent());
};

export const editStep = (stepName: string) => async dispatch => {
  if(stepName!=='endStep')
    await dispatch(gtmEvent('Edition', associativeGtmStepNameMap.get(stepName), '0'));

  dispatch(goToStep(stepName));
};

// TODO: faire le bon appel
export const actionSummaryNextStep = (reCaptchaValue?) => async (dispatch, getState) => {
  const { subscriptionNumber, offers } = await getState().subscription;
  const { recaptchaActivated, recaptchaSiteKey } = await getState().config;

  const customer = await getState().customer;

  let success;

  if (subscriptionNumber) {
    success = await dispatch(saveCustomer(customer));
  } else if (recaptchaActivated && recaptchaSiteKey !== '') {
    success = await dispatch(createPendingSubscription(customer, offers, reCaptchaValue));
  } else {
    success = await dispatch(createPendingSubscription(customer, offers));
  }

  if (!success) return;

  const { currentStep } = await getState().step;

  await dispatch({ type: ACTION_TYPES.DISABLE_BUTTONS, payload: { disableButtons: true } });
  await dispatch({ type: ACTION_TYPES.UPDATE_STEP, payload: { previousStep: currentStep, currentStep: currentStep + 1 } });

  dispatch(majCmsContent());
};

export const initializeHome = (numberSubscription: string, shortOfferCode: string) => async (dispatch, getState) => {
  if (numberSubscription !== undefined) {
    await dispatch(buildSteps());

    // const signed = await subscriptionApi.requestSubscriptionSignStatus(numberSubscription)
    await dispatch(getSubscription(numberSubscription));
    const subscription = await getState().subscription;

    // Si aucune adhésion trouvée (ex : 401 ou objet vide), on redirige vers le debut du parcours
    if (!subscription || !subscription.subscriptionNumber) {
      await dispatch({ type: ACTION_TYPES.SET_STEPS_LOADED });
      history.replace('/subscribe');
      return;
    }

    const { currentStep, journeyStepsList } = await getState().step;
    const currentStepName = journeyStepsList[currentStep - 1];
    if (currentStepName !== 'cancellationStep') {
      if (subscription?.status === 'VALIDATED') {
        await dispatch(goToStep('endStep'));
      } else if (subscription?.status === 'VALIDATED' && subscription.status !== 'PENDING') {
        await dispatch(goToStep('tooLateStep'));
      } else if (subscription?.status === 'VALIDATED' && subscription.legalEndDateReflection > new Date()) {
        await dispatch(goToStep('tooEarlyStep'));
      } else if (subscription?.status === 'PENDING') {
        await dispatch(goToStep('newCustomerInformationStep'));
      } else if (subscription?.status === 'SIGNING_IN_PROGRESS') {
        await dispatch(goToStep('signatureStep'));
      }
    }
  } else {
    await dispatch(initializeJourney(shortOfferCode));
    await dispatch(buildSteps());
  }

  await dispatch({ type: ACTION_TYPES.SET_STEPS_LOADED });
};

export const initializeCallback = (stepName: string, subscriptionNumber: string) => async (dispatch, getState) => {
  await dispatch(buildSteps());

  // sign (true si signé et false si non signé)
  // const signed = await subscriptionApi.requestSubscriptionSignStatus(subscriptionNumber)
  await dispatch(getSubscription(subscriptionNumber));
  const subscription = await getState().subscription;

  // Si confirmation && les documents ne sont pas signés > error
  if (stepName === 'confirmationStep' && subscription.subscriptionNumber && subscription?.status !== 'VALIDATED') {
    history.replace('/' + subscriptionNumber + '/failure?error=documentsnotsigned');
    return;
  } else if (stepName === 'confirmationStep' && !subscription.subscriptionNumber) {
    history.replace('/' + subscriptionNumber + '/failure');
    return;
  }

  if(subscription?.status === 'VALIDATED')
    await dispatch(gtmEvent('Adhésion', 'Valide', '0'));
  // sinon affiche l'étape
  await dispatch(editStep('endStep'));

  history.replace('/' + subscriptionNumber);
};

export const goNextStep = () => async (dispatch, getState) => {
  const { disableButtons, disableNextButton, actionBeforeNextStep, currentStep, actionNextStep, journeyStepsList } = getState().step;

  if (journeyStepsList[currentStep - 1] === 'cancellationStep' || journeyStepsList[currentStep - 1] === 'confirmationStep') return;

  if (disableButtons || disableNextButton) return;

  await dispatch({ type: ACTION_TYPES.DISABLE_BUTTONS, payload: { disableButtons: true } });

  if (actionBeforeNextStep !== null && actionBeforeNextStep !== undefined && !(await actionBeforeNextStep())) {
    await dispatch({ type: ACTION_TYPES.DISABLE_BUTTONS, payload: { disableButtons: false } });
    return;
  }

  if (actionNextStep !== null && actionNextStep !== undefined) {
    await actionNextStep();
    return;
  }

  await dispatch({ type: ACTION_TYPES.UPDATE_STEP, payload: { previousStep: currentStep, currentStep: currentStep + 1 } });

  dispatch(majCmsContent());

  await dispatch(gtmEvent(associativeGtmStepNameMap.get(journeyStepsList[currentStep - 1]), 'Suivant', '0'));
};

export const goPreviousStep = () => async (dispatch, getState) => {
  const { disableButtons, disablePreviousButton, actionBeforePreviousStep, currentStep, journeyStepsList } = getState().step;

  if (currentStep === 1 || disableButtons || disablePreviousButton) return;

  dispatch({ type: ACTION_TYPES.DISABLE_BUTTONS, payload: { disableButtons: true } });

  if (actionBeforePreviousStep !== null && actionBeforePreviousStep !== undefined) await actionBeforePreviousStep();

  if (currentStep > 1) {
    dispatch({ type: ACTION_TYPES.UPDATE_STEP, payload: { previousStep: currentStep - 2, currentStep: currentStep - 1 } }); // TODO : check utility previousStep
  }

  await dispatch(gtmEvent(associativeGtmStepNameMap.get(journeyStepsList[currentStep - 1]), 'Précédent', '0'));
};

export const checkIban = async (iban: string) => {
  const response = await journeyApi.checkIban(iban);
  return response.data;
};

export const initProductsStep = () => dispatch => {
  dispatch(initializeInsuredGoods());
};

export const getCheckSum = async (subscriptionNumber: number, shortOfferCode: string) => {
  const result = await journeyApi.getCheckSum(subscriptionNumber, shortOfferCode);

  return result.data;
};


// API SUBSCRIPTION PROCESS

export const actionSubscriptionNextStep = (reCaptchaValue?: string) => async (dispatch, getState) => {
    const state = getState();

    const { subscriptionProcessing, currentStep, journeyStepsList } = state.step;
    const { status, subscriptionNumber } = state.subscription;
    const { recaptchaActivated, recaptchaSiteKey, offer } = state.config;
    const customer = state.firstCustomer;

    const defaultOffer = offer?.defaultOffer;

    // Tracking GTM du step actuel
    const currentStepName = associativeGtmStepNameMap.get(
      journeyStepsList[currentStep - 1]
    );
    await dispatch(gtmEvent(currentStepName, "Suivant", "0"));

    // Empêche les multiples clics
    if (subscriptionProcessing) {
      console.log("Subscription is already being processed");
      return;
    }

    dispatch({
      type: ACTION_TYPES.SET_SUBSCRIPTION_PROCESSING,
      payload: true,
    });

    let success;

    try {
      // ⚡ UPDATE EXISTING SUBSCRIPTION
      if (subscriptionNumber) {
        console.log("UPDATE EXISTING SUBSCRIPTION");

        success = await dispatch(
          updateCustomerSubscription(subscriptionNumber, customer)
        );
      }
      // ⚡ CREATE NEW SUBSCRIPTION
      else {
        console.log("CREATE NEW SUBSCRIPTION");

        if (!defaultOffer) {// TODO : selected offer or defaultOffer
          console.error("❌ Missing defaultOffer!");
          throw new Error("Default offer is required to create a subscription");
        }

        const useRecaptcha = recaptchaActivated && recaptchaSiteKey;
        success = await dispatch(
          createPendingSubscriptionProcess(
            customer,
            defaultOffer,
            useRecaptcha ? reCaptchaValue : undefined
          )
        );

        // ⚡ UPDATE RIGHT AFTER CREATION
        if (success) {
          const newSubscriptionId = getState().subscription.subscriptionNumber;

          if (newSubscriptionId) {
            console.log("UPDATE NEWLY CREATED SUBSCRIPTION");

            success = await dispatch(
              updateCustomerSubscription(newSubscriptionId, customer)
            );
          }
        }
      }

      // ❌ ÉCHEC : stop et réactive les boutons
      if (!success) {
        dispatch({
          type: ACTION_TYPES.SET_SUBSCRIPTION_PROCESSING,
          payload: false,
        });
        return;
      }

      // 🔒 Désactivation des boutons
      await dispatch({
        type: ACTION_TYPES.DISABLE_BUTTONS,
        payload: { disableButtons: true },
      });

      // 📌 Si pas doublon → NEXT STEP
      if (status !== "DUPLICATE") {
        await dispatch({
          type: ACTION_TYPES.UPDATE_STEP,
          payload: {
            previousStep: currentStep,
            currentStep: currentStep + 1,
          },
        });
      }

      // 🔄 MAJ CMS
      dispatch(majCmsContent());
    } finally {
      // Toujours remettre subscriptionProcessing à false
      dispatch({
        type: ACTION_TYPES.SET_SUBSCRIPTION_PROCESSING,
        payload: false,
      });
    }
  };

